import { Selector, State } from "./types";
import { match } from "./utils";

function createSelector(getState: () => State): Selector {
  return {
    getResourceProjects(resource, query) {
      const state = getState().find(
        (req) => req.resource.uuid === resource.uuid && match(req.query, query),
      );

      return state ? state.projects : [];
    },
    canRetrieveNextResourceProjects(resource, query) {
      const state = getState().find(
        (req) => req.resource.uuid === resource.uuid && match(req.query, query),
      );

      return state ? state.canRetrieveNextProjects : true;
    },
    getResourceProjectsCursor(resource, query) {
      const state = getState().find(
        (req) => req.resource.uuid === resource.uuid && match(req.query, query),
      );

      return state ? state.cursor : 0;
    },
    isRetrieveResourceProjectsRequestFailure(resource, query) {
      const state = getState().find(
        (req) => req.resource.uuid === resource.uuid && match(req.query, query),
      );

      return state ? state.request.isFailure : false;
    },
    isRetrieveResourceProjectsRequestPending(resource, query) {
      const state = getState().find(
        (req) => req.resource.uuid === resource.uuid && match(req.query, query),
      );

      return state ? state.request.isPending : false;
    },
    isRetrieveResourceProjectsRequestSuccess(resource, query) {
      const state = getState().find(
        (req) => req.resource.uuid === resource.uuid && match(req.query, query),
      );

      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
